import ContentPanel from '../../display/ui/ContentPanel';
import ScreenContainer from '../../display/ui/ScreenContainer';
import LoadDisplay from '../../display/ui/LoadDisplay';
import Hud from '../hud/Hud';
import { GetDefaultButtonCostume } from '../hud/HudConstants';
import { GetLocationSelfieUrl } from '../../constants/AppUrls';

/**
 * Displays a video in an overlay container
 * @param {Phaser.Game} game - Phaser game state
 * @param {string} videokey - key of video to display, if a url is provided this will take priority
 * @param {string} videourl - Url of video to display ( absolute or relative ), if a key is provided that will take priority
 */
export default class ScreenOverlayVideo extends ScreenContainer {
  constructor(game, { videokey, videourl, locationid }) {
    super(game, { background: 'background_alt_overlay', modal: true });

    this.onScreenClosed = new Phaser.Signal();

    this.locationid = locationid;
    this.liked = this.game.gameController.player.getVideoLiked(locationid);

    // create the content panel that houses the video
    this.contentPanel = new ContentPanel(this.game, { width: 911, height: 458 });
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    this.contentPanel.onClosePanel.add(this.closePanel, this);
    this.add(this.contentPanel);

    // create a loader, we'll probably need this
    this.loadDisplay = new LoadDisplay(this.game, false);
    this.loadDisplay.scale.set(
      Math.min(1, (this.contentPanel.width / this.loadDisplay.width) * 0.5)
    );
    this.loadDisplay.x = this.contentPanel.width * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.contentPanel.height * 0.5 - this.loadDisplay.height * 0.5;
    this.contentPanel.add(this.loadDisplay);

    // if key supplied, just play the video - otherwise load one in
    if (videokey) {
      this.playVideo(videokey);
    } else if (videourl) {
      this.loadVideo(videourl);
    }
  }

  // if theselfie has not yet been liked, we need a btn
  addButton() {
    this.btnLike = Hud.CreateHudButton(GetDefaultButtonCostume('like'), this.game);
    this.btnLike.x = this.contentPanel.width - this.btnLike.width * 0.5;
    this.btnLike.y = this.contentPanel.height - this.btnLike.height * 0.5;
    this.btnLike.onInputDown.add(this.handleVideoLiked, this);
    this.contentPanel.add(this.btnLike);
  }

  // handle likiig video
  handleVideoLiked() {
    this.game.gameController.player.setVideoLiked(this.locationid);
    this.btnLike.destroy(true);
    this.btnLike = null;
    this.addIcon();
  }

  // if liked, we show icon
  addIcon() {
    this.iconLike = this.game.make.image(0, 0, 'buttons_sprite', 'btn_like_pink');
    this.iconLike.x = this.contentPanel.width - this.iconLike.width * 0.5;
    this.iconLike.y = this.contentPanel.height - this.iconLike.height * 0.5;
    this.contentPanel.add(this.iconLike);
  }

  /*
  =======================================================================================================
    LOAD VIDEO
  =======================================================================================================
  */

  loadVideo(videourl) {
    this.videourl = videourl;
    this.game.load.baseURL = '';
    this.game.load.video(videourl, videourl, 'canplaythrough');
    this.game.load.onLoadComplete.add(this.handleVideoLoaded, this);
    this.game.load.start();
  }

  handleVideoLoaded() {
    this.loadDisplay.visible = false;
    this.playVideo(this.videourl);
  }

  /*
  =======================================================================================================
    PLAY VIDEO
  =======================================================================================================
  */

  playVideo(videokey) {
    if (this.video) {
      this.video.destroy();
      this.videoSprite.destroy();
    }
    this.video = this.game.add.video(videokey);
    this.videoSprite = this.video.addToWorld(0, 0, 0.5, 0.5);
    this.videoSprite.scale.set(
      Math.max(
        this.contentPanel.height / this.video.height,
        this.contentPanel.width / this.video.width
      )
    );
    // position video
    this.videoSprite.x = this.contentPanel.width * 0.5;
    this.videoSprite.y = this.contentPanel.height * 0.5;
    this.contentPanel.x = this.game.defaultWidth * 0.5 - this.contentPanel.width * 0.5;
    this.contentPanel.y = this.game.defaultHeight * 0.5 - this.contentPanel.height * 0.5;
    this.contentPanel.addContent(this.videoSprite, false);

    this.playVideoImage = this.game.make.button(
      0,
      0,
      'buttons_sprite',
      this.hideVideoPlayImage,
      this,
      'btn_mainplay_pink',
      'btn_mainplay_white'
    );
    this.playVideoImage.scale.set(0.7);
    this.playVideoImage.x = this.contentPanel.width / 2 - this.playVideoImage.width / 2;
    this.playVideoImage.y = this.contentPanel.height / 2 - this.playVideoImage.height / 2;
    this.contentPanel.add(this.playVideoImage);

    this.video.onPlay.add(this.hideVideoPlayImage, this);
    this.video.play(true);

    // do we show button or icon?
    if (!this.liked) {
      this.addButton();
    } else {
      this.addIcon();
    }
  }

  update() {}

  hideVideoPlayImage() {
    this.playVideoImage.visible = false;
    // this.video.play(true);
  }

  /*
  =======================================================================================================
    CLOSE
  =======================================================================================================
  */

  closePanel() {
    if (this.video) {
      //this.video.stop();
    }
    this.onScreenClosed.dispatch(this);
  }

  /*
  =======================================================================================================
    DESTROY
  =======================================================================================================
  */

  destroy() {
    this.loadDisplay.destroy();

    // destroy video sprite
    if (this.videoSprite) {
      this.videoSprite.destroy(true);
      this.videoSprite = null;
    }

    if (this.btnLike) {
      this.btnLike.destroy();
      this.btnLike = null;
    }
    if (this.iconLike) {
      this.iconLike.destroy();
      this.iconLike = null;
    }
    if (this.playVideoImage) {
      this.playVideoImage = null;
    }

    // cleanup video
    if (this.video) {
      this.video.stop();
      this.video.onPlay.remove(this.hideVideoPlayImage, this);

      // There is a bud in Phaser's video class where destroy was trying to call amethod that don't exist
      // Just by passing it now and going in raw :)
      // this.video.destroy(true);
      if (this.video.touchLocked) {
        this.game.input.removeTouchLockCallback(this.video.unlock, this.video);
      }
      this.video.removeVideoElement();
      if (this.video._retryID) {
        window.clearTimeout(this.video._retryID);
      }

      this.video = null;
    }

    // if url was supplied, clean up cache and load events
    if (this.videourl) {
      this.game.load.onLoadComplete.remove(this.handleVideoLoaded, this);
      this.game.cache.removeVideo(this.videourl);
    }

    // destroy panel
    this.contentPanel.destroy(true);
    this.contentPanel = null;

    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/overlays/ScreenOverlayVideo.js